import styles from "./HighlightCard.module.css";

const HighlightCard = ({ icon: Icon, value, title, description }) => {  return (
    <div className={styles.card}>
      <div className={styles.iconWrapper}>
<div className={styles.iconWrapper}>
  {Icon && <Icon size={25} />}
</div>      </div>

      <div className={styles.content}>
        <h3 className={styles.value}>{value}</h3>
        <p className={styles.title}>{title}</p>
        {description && (
          <p className={styles.description}>{description}</p>
        )}
      </div>
    </div>
  );
};

export default HighlightCard;